export interface SkillPageConfig {
  title: string;
  heading: string;
  description: string;
  skills: string[];
}

export const SKILL_PAGES: Record<string, SkillPageConfig> = {
  'claude-code': {
    title: 'Claude Code Experts',
    heading: 'Hire Claude Code Experts',
    description:
      'Find and hire vetted Claude Code developers and consultants. Build AI-powered applications, automate workflows, and integrate Claude into your stack with expert guidance.',
    skills: ['Claude', 'Claude Code', 'Anthropic', 'Claude API', 'Anthropic API'],
  },
  'ai-agents': {
    title: 'AI Agent Developers',
    heading: 'Hire AI Agent Developers',
    description:
      'Find vetted AI agent developers for custom agentic solutions. Build autonomous AI agents, multi-agent systems, and intelligent automation for your business.',
    skills: ['AI Agents', 'Agentic AI', 'Agent Development', 'LangChain', 'CrewAI', 'multiagent', 'langchain'],
  },
  'machine-learning': {
    title: 'Machine Learning Engineers',
    heading: 'Hire Machine Learning Engineers',
    description:
      'Connect with experienced machine learning engineers. Build predictive models, recommendation systems, and custom ML pipelines tailored to your data.',
    skills: ['Machine Learning', 'ML', 'Deep Learning', 'TensorFlow', 'PyTorch'],
  },
  'ai-consulting': {
    title: 'AI Consultants',
    heading: 'Hire AI Consultants',
    description:
      'Work with top AI consultants who help businesses identify AI opportunities, build strategy, and implement solutions that deliver real ROI.',
    skills: ['AI Consulting', 'AI', 'AI Strategy', 'AI Audits and Roadmaps'],
  },
  'nlp': {
    title: 'NLP Experts',
    heading: 'Hire NLP Experts',
    description:
      'Find natural language processing specialists. Build text analysis, sentiment detection, chatbots, and language understanding systems.',
    skills: ['Natural Language Processing', 'NLP', 'Text Analytics', 'Sentiment Analysis'],
  },
  'generative-ai': {
    title: 'Generative AI Experts',
    heading: 'Hire Generative AI Experts',
    description:
      'Connect with generative AI specialists. Build custom LLM applications, fine-tune models, implement RAG systems, and create AI-powered content generation tools.',
    skills: ['Generative AI', 'GenAI', 'LLMs', 'RAG', 'RAG & Fine Tuning', 'Fine Tuning'],
  },
  'prompt-engineering': {
    title: 'Prompt Engineers',
    heading: 'Hire Prompt Engineers',
    description:
      'Work with expert prompt engineers who design, optimize, and systematize AI prompts for maximum output quality and reliability.',
    skills: ['Prompt Engineering', 'Prompt Design', 'Prompt Optimization'],
  },
  'data-science': {
    title: 'Data Scientists',
    heading: 'Hire Data Scientists',
    description:
      'Find freelance data scientists for analytics, modeling, and data-driven decision making. From exploratory analysis to production ML pipelines.',
    skills: ['Data Science', 'Data Analytics', 'Data Engineering', 'Python', 'Statistics'],
  },
  'ai-automation': {
    title: 'AI Automation Experts',
    heading: 'Hire AI Automation Experts',
    description:
      'Connect with AI automation specialists who build intelligent workflows, automate business processes, and integrate AI into your operations.',
    skills: ['AI Automation', 'Automation', 'AI Automations & Integrations', 'AI-driven Efficiency Solutions'],
  },
  'mcp-development': {
    title: 'MCP Server Developers',
    heading: 'Hire MCP Server Developers',
    description:
      'Find Model Context Protocol developers. Build custom MCP servers, integrate AI tools with your systems, and extend Claude with specialized capabilities.',
    skills: ['MCP', 'Model Context Protocol', 'Claude Code', 'Claude API'],
  },
  'claude-integration': {
    title: 'Claude AI Integration Specialists',
    heading: 'Hire Claude AI Integration Specialists',
    description:
      'Work with experts who integrate Claude AI into business applications. From API integration to enterprise deployment and custom tool building.',
    skills: ['Claude', 'Claude API', 'Anthropic', 'Claude Code', 'AI Integration'],
  },
  'claude-certified': {
    title: 'Claude Certified Architects',
    heading: 'Hire Claude Certified Architects',
    description:
      'Connect with Claude Certified Architect professionals who have demonstrated deep expertise in building with Anthropic\'s Claude platform.',
    skills: ['Claude', 'Claude Code', 'Anthropic', 'Claude API', 'AI Consulting'],
  },
  'chatbot-development': {
    title: 'AI Chatbot Developers',
    heading: 'Hire AI Chatbot Developers',
    description:
      'Find chatbot developers who build intelligent conversational AI. From customer support bots to complex multi-turn dialogue systems.',
    skills: ['Chatbot', 'Conversational AI', 'Chat Development', 'NLP', 'Natural Language Processing'],
  },
  'computer-vision': {
    title: 'Computer Vision Engineers',
    heading: 'Hire Computer Vision Engineers',
    description:
      'Connect with computer vision specialists. Build image recognition, object detection, video analysis, and visual AI applications.',
    skills: ['Computer Vision', 'Image Recognition', 'Object Detection', 'OpenCV'],
  },
  'workflow-automation': {
    title: 'Workflow Automation Specialists',
    heading: 'Hire Workflow Automation Specialists',
    description:
      'Find experts in AI-powered workflow automation. Build with n8n, Zapier, Make, and custom automation pipelines that save your team hours every week.',
    skills: ['Workflow Automation', 'n8n', 'Automation', 'Business Process Optimization', 'AI Automation'],
  },
};

export const SKILL_SLUGS = Object.keys(SKILL_PAGES);

/** Top skill pages to feature in footer and navigation */
export const FEATURED_SKILL_SLUGS = [
  'claude-code',
  'ai-consulting',
  'ai-agents',
  'machine-learning',
  'prompt-engineering',
  'generative-ai',
] as const;
